<template>
  <div class="container d-flex justify-content-center align-items-center vh-100">
    <div class="login-card p-5 shadow">
      <h2 class="text-center mb-4">Login</h2>
      <form @submit.prevent="login">
        <div class="form-group mb-3">
          <label for="username" class="form-label">Benutzername</label>
          <input
            v-model="username"
            type="text"
            id="username"
            class="form-control"
            placeholder="Benutzername"
            required
          />
        </div>
        <div class="form-group mb-4">
          <label for="password" class="form-label">Passwort</label>
          <input
            v-model="password"
            type="password"
            id="password"
            class="form-control"
            placeholder="Passwort"
            required
          />
        </div>
        <button type="submit" class="btn btn-primary w-100" :disabled="loading">
          {{ loading ? 'Wird angemeldet...' : 'Anmelden' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios';
import { authState as auth } from '@/auth';

export default {
  data() {
    return {
      username: '',
      password: '',
      loading: false
    };
  },
  methods: {
    async login() {
      this.loading = true;
      try {
        const res = await axios.post('/auth/login', {
          username: this.username,
          password: this.password
        });
        const token = res.data.accessToken || res.data.token || res.data.data?.token;
        if (!token) {
          alert('Login fehlgeschlagen: kein Token erhalten');
          return;
        }
        auth.login(token);
        this.$router.push({ name: 'MainMenu' });
      } catch (err) {
        alert(err.response?.data?.message || 'Login fehlgeschlagen');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>


<style scoped>
.container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-card {
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  padding: 40px;
  text-align: center;
}
.form-label {
  font-weight: bold;
}
.form-control {
  border-radius: 10px;
  padding: 10px;
  font-size: 16px;
}
.btn {
  font-size: 18px;
  padding: 10px 20px;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}
.btn-primary:hover {
  background-color: var(--primary-color-dark);
}
</style>
